package com.dotdrives.web.pages.donations

import com.dotdrives.controller.StatementDocumentController
import com.dotdrives.model.GivingStatement
import com.dotdrives.repository.SupabaseWorkflowRepository
import com.dotdrives.web.ui.*
import kotlinx.coroutines.*
import react.*
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

external interface StatementDeliveryPanelProps : Props {
    var orgId: String
    var userId: String
    var role: String
    var statements: List<GivingStatement>
}

val StatementDeliveryPanel =
    FC<StatementDeliveryPanelProps> { props ->
        val delivery = useWorkflowController(props.userId, props.orgId, props.role)
        val state = useFlowState(delivery.state)
        val (holder) =
            useState {
                val scope = MainScope()
                scope to StatementDocumentController(SupabaseWorkflowRepository(), scope)
            }
        val doc = useFlowState(holder.second.state)
        useEffect(holder) {
            try {
                awaitCancellation()
            } finally {
                holder.first.cancel()
            }
        }
        useEffect(props.statements) { delivery.loadJobs() }
        WorkflowFeedback {
            controller = delivery
            this.state = state
        }
        doc.error?.let { DotBanner { message = it } }
        props.statements.forEach { statement ->
            div {
                key = statement.id.unsafeCast<Key>()
                className = ClassName("workflow-card")
                div {
                    +"${statement.giverDisplayName} · ${formatMoneyFull(statement.totalAmount)} snapshot saved"
                }
                val ready =
                    (doc.id == statement.id && doc.document?.status == "ready") ||
                        statement.generatedAt != null
                val emailJobs =
                    state.jobs.filter {
                        it.kind == "email.statement" && it.references(statement.id)
                    }
                val accepted =
                    statement.emailedAt?.toString()
                        ?: emailJobs.firstOrNull { it.status == "accepted" }?.acceptedAt
                div { +(if (ready) "PDF ready" else "PDF status not checked — open PDF to check") }
                div {
                    +(accepted?.let { "Accepted by email provider · $it" }
                        ?: "No provider acceptance recorded")
                }
                if (
                    emailJobs.isEmpty() &&
                        accepted == null &&
                        !state.jobsLoading &&
                        state.jobsError == null
                )
                    DotButton {
                        text = "Queue statement email"
                        enabled = !state.busy
                        onClick = {
                            delivery.perform(
                                "workflows",
                                "statement.request",
                                mapOf(
                                    "giver_id" to statement.giverId,
                                    "year" to statement.year.toString(),
                                ),
                            )
                        }
                    }
                DotButton {
                    text = "Open PDF"
                    enabled = !doc.loading
                    onClick = { holder.second.open(statement.id) }
                }
                if (doc.id == statement.id) {
                    val result = doc.document
                    if (result?.status == "ready" && result.url != null)
                        a {
                            href = result.url
                            +"Download PDF (link expires in five minutes)"
                        }
                    else
                        result?.let {
                            div { +"Document ${it.status}" }
                            if (it.retryable)
                                DotButton {
                                    text = "Retry PDF generation"
                                    onClick = { holder.second.open(statement.id, true) }
                                }
                        }
                }
                DeliveryJobs {
                    controller = delivery
                    this.state = state
                    sourceId = statement.id
                }
            }
        }
    }
